// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"266":"648d785b","831":"b72496a5"}[chunkId] + ".css";
};